module.exports = __webpack_public_path__ + "static/media/logo_acb.f7d2a37a.svg";